import sideQuest from './images/side-quest.png';
import metaAbcs from './images/meta-abcs.png';
import marketMadness from './images/market_madness.png';
import googleHackathon from './images/google_hbcu_hackathon.png';
import googleCoding from './images/google_coding_challenge.png';
import bisonHacks from './images/bison_hack.png';
import udacityCertificate from './images/udacity.png';
import codepathCertificate from './images/codepath.png';

export const certificates = [
    {
        title: "AWS AI Practitioner Challenge",
        file: "/Certificate.pdf",
        icon: "🏆",
        image: udacityCertificate
    },
    {
        title: "Codepath Foundation of AI Engineering",
        file: "/Manish Niure.pdf",
        icon: "🎓",
        image: codepathCertificate
    }
];

export const extracurriculars = [
    {
        title: "VTHACKS 12 - Virginia Tech University Hackathon",
        role: "Team Work",
        date: "Sept 2024",
        image: sideQuest,
        description:
            "Developed SideQuest, a React-based web app leveraging machine learning to match user preferences with location types. Integrated Google Maps API and reinforcement learning to optimize trip recommendations.",
        link: "https://devpost.com/software/sidequest-ut0xaz", 
    },
    {
        title: "Above and Beyond Computer Science (ABCS) Program - Meta",
        role: "Participant",
        date: "Jan 2024 - Feb 2024",
        image: metaAbcs, 
        description:
            "Selected as one of 100+ participants globally for a 5-week program. Attended workshops focused on mastering technical interview skills, knowledge, and mindsets.",
        link: "https://www.meta.com/abcs", 
    },
    {
        title: "Goldman Sachs - HBCU Market Madness",
        role: "Team Lead",
        date: "April 2023",
        image: marketMadness, 
        description:
            "Led a team of 5 students to develop an acquisition proposal for L'Oréal, emphasizing strategic growth and market expansion.",
        link: "https://www.goldmansachs.com/hbcu-market-madness", 
    },
    {
        title: "Google HBCU Hackathon",
        role: "Team Work",
        date: "March 2023",
        image: googleHackathon, 
        description:
            "Worked in a group of 4 to build a housing app using HTML, CSS, Flask, and Swift. Presented the prototype to Google Engineers and received recognition for the innovative idea, despite not winning the competition.",
        link: "https://docs.google.com/presentation/d/1ut21_vCBotc8dGdXdue23d6tSLNKBQJ2kOCGZvmabws/edit?usp=sharing", 
    },
    {
        title: "Google HBCU/HSI Coding Challenge",
        role: "Participant",
        date: "April 2023",
        image: googleCoding,
        description:
            "Participated in the coding challenge organized by Google. Entered the second round as part of one of the top teams, competing against 50+ other teams on solving data structure and algorithms problem.",
        link: "https://docs.google.com/presentation/d/1ut21_vCBotc8dGdXdue23d6tSLNKBQJ2kOCGZvmabws/edit?usp=sharing",
    },
    {
        title: "BISON HACKS",
        role: "Team Work",
        date: "March 2022",
        image: bisonHacks,
        description:
            "A team of 4 international students from Nepal developed International+, a platform aimed at assisting international students in navigating challenges like finding housing, on-campus jobs, classrooms, and other essential resources to ease their transition to Howard University and beyond",
        link: "https://devpost.com/software/international-c8w3he",
    }
];